import React from 'react';
import PropTypes from 'prop-types';
import BundledItemLine from './BundledItemLine.js';
import { Config, formatPrice, I18n } from '@deporvillage/utils-library-component';

import styles from './ActionGroup.module.scss';

const ActionGroup = ({ items, click, isAdded, id }) => {
    const { lang, featureFlags } = React.useContext(Config);
    const [stateItems, setItems] = React.useState(items);
    const [errorNotSelected, setErrorNotSelected] = React.useState(null);
    const [activeButton, setActiveButton] = React.useState(null)
    const [isAddedBundle, setIsAddedBundle] = React.useState(false);
    const ref = React.useRef(null);

    const handleClick = (e) => {
        e.preventDefault();

        // @toDo FeatureFlag
        if (featureFlags?.enableNewAddToCart) {
            setItems(stateItems.map(i => ({ ...i, error: !i.uuid })));
        } else {
            setItems(stateItems.map(i => ({ ...i, error: !i.id })));
        }

        const itemsWithVariantsNotSelected = stateItems.filter(i => i.variants.length && (!i.selected));
        if (itemsWithVariantsNotSelected && itemsWithVariantsNotSelected.length) {
            setErrorNotSelected(itemsWithVariantsNotSelected);
            return;
        }

        setActiveButton(ref?.current?.id);
        click && click(stateItems);
    };

    /* istanbul ignore next */
    const handleUpdate = (o) => {
        const idx = stateItems.findIndex(e => e.id === o.id);
        let items = [...stateItems];
        items[idx] = o;
        setItems(items);
        setErrorNotSelected(null);
    };

    let prices = stateItems.reduce((l, i) => ({
        pvp: l.pvp + ((i.totalPvp || i.default_variant.price.pvp)),
        price: l.price + ((i.totalPrice || i.default_variant.price.price))
    }), { pvp: 0, price: 0 });

    /* istanbul ignore next */
    React.useEffect(()=> {
        (id === activeButton && isAdded) && setIsAddedBundle(true);

        setTimeout(() => {
            setActiveButton(null);
            setIsAddedBundle(false);
        }, 3500);
    }, [activeButton, isAdded, id]);

    return (
        <div className={styles['bundled-items-action-group']}>
            <div>
                { stateItems.map(i => (
                    <BundledItemLine key={ i.id } item={ i } update={ handleUpdate } error={errorNotSelected} />
                )) }
            </div>

            <div className={styles['summary']}>
                <div className={styles['summary-price']}>
                    <span className={styles['price-special']}>
                        { formatPrice(prices.price, stateItems[0].default_variant.price.currency_code, lang) }
                    </span>
                    <span className={styles['price-old']}>
                        { formatPrice(prices.pvp, stateItems[0].default_variant.price.currency_code, lang) }
                    </span>
                </div>
                <div className={styles['summary-button']}>
                <button ref={ref} id={id} onClick={handleClick} className={`${styles['action-group-button']} ${isAddedBundle ? styles['added'] : ''}`}>
                        {isAddedBundle ? (
                            <>
                                <i className={`${styles['icon']} icon icon-done`} />
                                <span>
                                    <I18n>product_page.actions.added_to_cart</I18n>
                                </span>
                            </>
                        ) : (
                            <>
                                <i className={`${styles['icon']} icon icon-add-shopping-cart`} />
                                <span>
                                    <I18n>product_page.actions.add_to_cart</I18n>
                                </span>
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

ActionGroup.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            totalPrice: PropTypes.number,
            totalPvp: PropTypes.number,
            name: PropTypes.string,
            selectedOptionValue: PropTypes.string,
            default_variant: PropTypes.shape({
                price: PropTypes.shape({
                    pvp: PropTypes.number,
                    base: PropTypes.number,
                    currency_code: PropTypes.string,
                }),
            }),
        })
    ),
    click: PropTypes.func,
    isAdded: PropTypes.bool,
    id: PropTypes.string,
};

export default ActionGroup;
